module.exports = __webpack_public_path__ + "img/Checkout.eca02cad.svg";